import { Component, ViewChild } from "@angular/core";
import { BaseEntity, BaseState, CredentialType } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { DataSourceCustomAction } from "@base/datalayer/BaseDataSources";
import { GridExtender } from "@base/grid/Grid.extender";
import { CredentialActivityStatusGridComponent } from './grid/credentials-activity-status-grid.component';
import { CredentialActivityEndpoint } from "@core/endpoints/credential-activity.endpoint";

class State extends BaseState {
    CredentialsInfo: CredentialType[] = [];
    CredentialType: number = -1;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-credentials-activity-status',
    templateUrl: './credentials-activity-status.component.html',
    styleUrls: ['./credentials-activity-status.component.scss']
})

export class CredentialsActivityStatusComponent extends BasePageComponent<BaseEntity, State>{
    @ViewChild('credentialActivityGrid') credentialActivityGrid: CredentialActivityStatusGridComponent;
    public get G(): GridExtender {
        return this.credentialActivityGrid?.G;
    }

    constructor(A: ServiceBagService, private credentialActivityEndpoint: CredentialActivityEndpoint) {
        super(A, 'CredentialsActivityStatusComponent', BaseEntity, State);
    }

    override OnInitDataSources() {
        this.LoadDataSource();
        this.Do(this.credentialActivityEndpoint.ListCredentialTypes(), false, (response) => {
            this.State.CredentialsInfo = response.Entities;

            response.Entities.forEach(entity => {
                if (entity.Value == null) {
                    entity.Value = -999;
                }
            });
        });
    }

    private LoadDataSource() {
        this.DataSources['Data'] = new DataSourceCustomAction(
            (options) => this.credentialActivityEndpoint.ListActivity(this.State.CredentialType ?? -999, options),
            undefined, (entities) => {
                entities.forEach(entity => {
                    if (entity.CredentialType == null) {
                        entity.CredentialType = -999;
                    }
                });
            }, false);
        this.DS('Data').Reload();
    }

    override OnGetToolbarSettings() {
        return {
            IsAllowFilter: true,
            IsAllowExport: true,
            GridExtender: this.G
        };
    }

    protected override OnApplyFilter() {
        this.LoadDataSource();
    }

    protected override OnClearFilter() {
        this.State.CredentialType = -1;
        this.LoadDataSource();
    }

    OnRefresh() {
        this.LoadDataSource();
    }
}
